export class v1_3_identity_switch_certificate_request {
  public user_name: string;
  public finance_centre_id: number;
}
